import { render, staticRenderFns } from "./Materi.vue?vue&type=template&id=6e7da090&"
import script from "./Materi.vue?vue&type=script&lang=js&"
export * from "./Materi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Materi.vue"
export default component.exports